export default __webpack_public_path__ + "static/media/view-all-destiations-AND-Gallery.fb84afcb.jpg";